import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Account } from "model";
/**
* @class PositivePayCheck
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @property {STRING} _account - The account of the check.
* @property {STRING} _accountName - The account name of the check.
* @property {STRING} _accountNumber - The account number of the check.
* @property {STRING} _issuedDate - The issued date of the check.
* @property {STRING} _checkNumber - The check number of the check.
* @property {STRING} _amount - The amount of the check.
* @property {STRING} _payee - The payee of the check.
* @property {STRING} _referenceNumber - The reference number of the check.
* @property {STRING} _type - The status type of the check.
* @property {STRING} _mobileViewIsOpen - A ui state of the check.
* @property {STRING} _mobileViewIsEditing - A ui state of the check.
* @extends BCMSRecord
* @example const record = model.positivePayChecks[0];
* const profile = new PositivePayCheck(record);
* @property {STRING} _id - The id of the positive pay check.
*/
export default class PositivePayCheck extends BCMSRecord {
    _id
    _account
    _accountName
    _accountNumber
    _issuedDate
    _checkNumber
    _amount
    _payee
    _referenceNumber
    _type
    _mobileViewIsOpen
    _mobileViewIsEditing

    constructor(record) {     
      super(record) 
    }
  }
  PositivePayCheck.define({
    "recordType": "positivePayChecks",
    "recordIDProp":"id",
    "className" : "PositivePayCheck",
    "recordProperties":[
        /** 
         * @name id
         * @instance
         * @property get {STRING} - gets the id 
         * @property set {STRING} - sets the id 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("id","_id"),

                /** 
         * @name account
         * @instance
         * @property get {STRING} - gets the id 
         * @property set {STRING} - sets the id 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToClass("account","_account", () => Account),

        /** 
         * @name accountName
         * @instance
         * @property get {STRING} - gets the accountName 
         * @property set {STRING} - sets the accountName 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("accountName","_accountName"),

        /** 
         * @name accountName
         * @instance
         * @property get {STRING} - gets the accountName 
         * @property set {STRING} - sets the accountName 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("accountNumber","_accountNumber"),

        /** 
         * @name issuedDate
         * @instance
         * @property get {STRING} - gets the issuedDate 
         * @property set {STRING} - sets the issuedDate 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("issuedDate","_issuedDate"),

        /** 
         * @name checkNumber
         * @instance
         * @property get {STRING} - gets the checkNumber 
         * @property set {STRING} - sets the checkNumber 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("checkNumber","_checkNumber"),

        /** 
         * @name amount
         * @instance
         * @property get {STRING} - gets the amount 
         * @property set {STRING} - sets the amount 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("amount","_amount"),

        /** 
         * @name payee
         * @instance
         * @property get {STRING} - gets the payee 
         * @property set {STRING} - sets the payee 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("payee","_payee"),

        /** 
         * @name referenceNumber
         * @instance
         * @property get {STRING} - gets the referenceNumber 
         * @property set {STRING} - sets the referenceNumber 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("referenceNumber","_referenceNumber"),

        /** 
         * @name type
         * @instance
         * @property get {STRING} - gets the type 
         * @property set {STRING} - sets the type 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("type","_type"),

        /** 
         * @name mobileViewIsOpen
         * @instance
         * @property get {STRING} - gets the mobileViewIsOpen 
         * @property set {STRING} - sets the mobileViewIsOpen 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("mobileViewIsOpen","_mobileViewIsOpen"),

        /** 
         * @name mobileViewIsEditing
         * @instance
         * @property get {STRING} - gets the mobileViewIsEditing 
         * @property set {STRING} - sets the mobileViewIsEditing 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("mobileViewIsEditing","_mobileViewIsEditing"),
        
    ]  
})




